import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './../styles/order-success.css';
import { Copy } from "lucide-react";
import ToastNotification, { showToast } from '../components/toasts/ToastNotification';
import {
  FaFacebookMessenger,
  FaShoppingBasket,
  FaRegCheckCircle,
  FaLightbulb,
} from "react-icons/fa";
import { IoReceiptSharp } from "react-icons/io5";
import { useSettings } from '../context/SettingsContext';

const TUTORIAL_URL = 'https://drive.google.com/file/d/1in8qyPfqUWg-fBfHERNhjo7xBP_tsAKW/view?fbclid=IwY2xjawKeOp5leHRuA2FlbQIxMQABHjhwab4wieCD1xx4hDLPn22DO2JptGFlBc813MW7fHvrCxbV_QO3P-LgKaWp_aem_62tXuLMMKQ_YLLXVYLI4JA';

const OrderSuccess = () => {
  const { state } = useLocation();
  const { orderId, product_type, order_attributes, isValuable } = state || {};
  const navigate = useNavigate();
  const settings = useSettings();

  const copyToClipboard = (text) => {
    showToast("Copy thành công", "success");
    navigator.clipboard.writeText(text);
  };

  const shouldShowCredentials = product_type === 'gift_card' || (product_type === 'game_account' && !isValuable);
  const shouldShowUtilData = product_type === 'utility_account' && !isValuable;

  const getSuccessMessage = () => {
    if (product_type === 'game_account') {
      return isValuable
        ? "Bạn vui lòng copy mã đơn hàng và nhắn tin qua Messenger để shop hỗ trợ thay đổi thông tin tài khoản."
        : "Vui lòng thay đổi thông tin Gmail để quản lí tài khoản của bạn, Gmail này sẽ bị xoá sau 3 ngày.";
    }
    if (product_type === 'topup_package') {
      return "Bạn vui lòng copy mã đơn hàng và nhắn tin qua Messenger để shop hỗ trợ nạp game cho mình ạ.";
    }
    if (product_type === 'utility_account' && isValuable) {
      return "Bạn vui lòng copy mã đơn hàng và nhắn tin qua Messenger để shop gửi tài khoản và mật khẩu cho mình ạ.";
    }
    return null;
  };

  const renderActions = () => {
    const actions = [
      {
        label: "Xem chi tiết đơn hàng",
        icon: <IoReceiptSharp />,
        action: () => navigate(`/order/${orderId}`)
      }
    ];

    // Game Account (not valuable) gets tutorial
    if (product_type === 'game_account' && !isValuable) {
      actions.push({
        label: "Hướng dẫn thay đổi thông tin",
        icon: <FaLightbulb />,
        action: () => window.open(TUTORIAL_URL, "_blank")
      });
    }

    // Valuable or requires support
    if (
      (product_type === 'game_account' && isValuable) ||
      (product_type === 'utility_account' || product_type === 'gift_card') ||
      product_type === 'topup_package'
    ) {
      actions.push({
        label: "Liên hệ qua Messenger",
        icon: <FaFacebookMessenger />,
        action: () => navigate(settings?.contact_messenger_url || "https://iampesmobile.com")
      });
    }

    return actions.map((btn, idx) => (
      <button key={idx} onClick={btn.action} className="view-order-btn">
        {btn.icon}{btn.label}
      </button>
    ));
  };

  return (
    <div className="order-success-container">
      <ToastNotification />
      <div className="order-success-card">
        <FaRegCheckCircle className='order-success-icon' />
        <h2 className="success-title">Đơn Hàng Thành Công</h2>

        <div className="order-details">
          <p className="order-id">
            <strong>Mã đơn hàng: </strong>
            <div className='order-id-copy-row'>
              <span className='orderId'>{orderId}</span>
              <Copy className="copy-icon" onClick={() => copyToClipboard(orderId)} />
            </div>
          </p>

          {shouldShowCredentials && (
            <div className='order-attributes-container'>
              <div className="order-success-product-username">
                <strong>Tên đăng nhập:</strong>
                <strong className='order-success-product-attributes-text'>{order_attributes?.username}</strong>
              </div>
              <p className="order-success-product-password">
                <strong>Mật khẩu:</strong>
                <strong className='order-success-product-attributes-text'>{order_attributes?.password}</strong>
              </p>
            </div>
          )}

          {shouldShowUtilData && (
            <div className='order-attributes-container'>
              {order_attributes.length > 0 && order_attributes.map((od) => (
                <div className="order-success-product-username">
                  <strong>{od.label}:</strong>
                  <strong className='order-success-product-attributes-text'>{od.value}</strong>
                </div>
              ))}
            </div>
          )}
        </div>

        {getSuccessMessage() && (
          <p className="success-message">{getSuccessMessage()}</p>
        )}

        <div className="cta-container">
          {renderActions()}
        </div>

        <p className="thanks-message">
          Cám ơn bạn đã tin tưởng và mua sắm tại Iampesmobile.com!
        </p>
      </div>
    </div>
  );
};

export default OrderSuccess;
